var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartShoppingFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4763_2353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.43 4.92C22.95 4.34 22.25 4 21.5 4H6.49L6.23 2.16C6.06 0.93 5 0 3.75 0H2.49C2.21 0 1.99 0.22 1.99 0.5C1.99 0.78 2.21 1 2.49 1H3.75C4.5 1 5.13 1.56 5.24 2.29L7.02 15.12C7.33 17.33 9.24 19 11.48 19H19.5C19.78 19 20 18.78 20 18.5C20 18.22 19.78 18 19.5 18H11.48C9.75 18 8.26 16.71 8.02 15H18.66C20.8 15 22.65 13.48 23.07 11.38L23.95 6.99C24.1 6.25 23.91 5.5 23.43 4.91V4.92ZM22.97 6.8L22.09 11.19C21.76 12.82 20.32 14 18.66 14H7.88L6.63 5H21.5C21.95 5 22.37 5.2 22.66 5.55C22.95 5.9 23.06 6.35 22.97 6.8ZM9 20.01C7.9 20.01 7 20.91 7 22.01C7 23.11 7.9 24.01 9 24.01C10.1 24.01 11 23.11 11 22.01C11 20.91 10.1 20.01 9 20.01ZM9 23.01C8.45 23.01 8 22.56 8 22.01C8 21.46 8.45 21.01 9 21.01C9.55 21.01 10 21.46 10 22.01C10 22.56 9.55 23.01 9 23.01ZM18 20.01C16.9 20.01 16 20.91 16 22.01C16 23.11 16.9 24.01 18 24.01C19.1 24.01 20 23.11 20 22.01C20 20.91 19.1 20.01 18 20.01ZM18 23.01C17.45 23.01 17 22.56 17 22.01C17 21.46 17.45 21.01 18 21.01C18.55 21.01 19 21.46 19 22.01C19 22.56 18.55 23.01 18 23.01ZM0 5.5C0 5.22 0.22 5 0.5 5H3.04C3.32 5 3.54 5.22 3.54 5.5C3.54 5.78 3.32 6 3.04 6H0.5C0.22 6 0 5.78 0 5.5ZM0 9.5C0 9.22 0.22 9 0.5 9H3.5C3.78 9 4 9.22 4 9.5C4 9.78 3.78 10 3.5 10H0.5C0.22 10 0 9.78 0 9.5ZM5 13.5C5 13.78 4.78 14 4.5 14H0.5C0.22 14 0 13.78 0 13.5C0 13.22 0.22 13 0.5 13H4.5C4.78 13 5 13.22 5 13.5Z",
    fill: "white",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4763_2353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartShoppingFast);
export default __webpack_public_path__ + "static/media/cart-shopping-fast.a43eb0734e342ac0d5f71fd8a6f8a65f.svg";
export { ForwardRef as ReactComponent };